import { render, staticRenderFns } from "./Germany.vue?vue&type=template&id=00700350"
import script from "./Germany.vue?vue&type=script&lang=js"
export * from "./Germany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports